import { MAX_FILE_SIZE, SUPPORTED_FORMATS } from './SignUpForms.const';

export function fileSizeValidation(file: File) {
  return file.size <= MAX_FILE_SIZE;
}

export function fileTypeValidation(file: File) {
  return SUPPORTED_FORMATS.includes(file.type);
}

export function maxNumbersAfterDecimalValidation(number: number) {
  return /^\d+(\.\d{0,5})?$/.test(number.toString());
}
